import React, { Component } from "react";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import sanitizeHtml from "sanitize-html";
import NumberFormat from "react-number-format";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";

// Components
import Select from "react-select";
import "react-select/dist/react-select.css";
import Loader from "../../utils/Loader";

// State
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class JerseyForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				additional_option: "None"
			},
			errors: {},
			playersLoading: true,
			submitLoading: false,
			players: [],
			productTypes: [
				{
					value: "Jersey",
					label: "Jersey"
				},
				{
					value: "T-Shirt",
					label: "T-Shirt"
				},
				{
					value: "Other",
					label: "Other"
				}
			],
			sizeTypes: [
				{
					value: "Adult - Small",
					label: "Adult - Small"
				},
				{
					value: "Adult - Medium",
					label: "Adult - Medium"
				},
				{
					value: "Adult - Large",
					label: "Adult - Large"
				},
				{
					value: "Adult - XL",
					label: "Adult - XL"
				},
				{
					value: "Adult - 2XL",
					label: "Adult - 2XL"
				},
				{
					value: "Adult - 3XL",
					label: "Adult - 3XL"
				},
				{
					value: "Adult - 4XL",
					label: "Adult - 4XL"
				},
				{
					value: "Youth - S/M",
					label: "Youth - S/M"
				},
				{
					value: "Youth - Small",
					label: "Youth - Small"
				},
				{
					value: "Youth - Medium",
					label: "Youth - Medium"
				},
				{
					value: "Youth - L/XL",
					label: "Youth - L/XL"
				},
				{
					value: "Youth - Large",
					label: "Youth - Large"
				},
				{
					value: "Youth - XL",
					label: "Youth - XL"
				},
				{
					value: "Other",
					label: "Other"
				}
			],
			styleTypes: {
				Jersey: [
					{
						value: "Red (QuickLite)",
						label: "Red (QuickLite)"
					},
					{
						value: "White (QuickLite)",
						label: "White (QuickLite)"
					},
					{
						value: "Red (Ladies Style)",
						label: "Red (Ladies Style)"
					},
					{
						value: "Blue (Old Style)",
						label: "Blue (Old Style)"
					},
					{
						value: "White (Old Style)",
						label: "White (Old Style)"
					},
					{
						value: "Blue (Ladies Style)",
						label: "Blue (Ladies Style)"
					},
					{
						value: "Classic (Royal)",
						label: "Classic (Royal)"
					},
					{
						value: "Mickey",
						label: "Mickey"
					},
					{
						value: "W Logo",
						label: "W Logo"
					},
					{
						value: "Other",
						label: "Other"
					}
				],
				"T-Shirt": [
					{
						value: "Airplane Logo",
						label: "Airplane Logo"
					},
					{
						value: "W Logo",
						label: "W Logo"
					},
					{
						value: "Other",
						label: "Other"
					}
				]
			},
			conditionTypes: [
				{
					value: "New",
					label: "New"
				},
				{
					value: "Customer Supplied",
					label: "Customer Supplied"
				}
			]
		};
	}

	componentDidMount() {
		this.loadData();
	}

	loadData() {
		const apiEndpoint = "custom/spitsgear/players";

		const AUTH_HEADER = {
			Authorization: REACT_APP_SITE_KEY
		};
		return axios
			.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({
						playersLoading: false,
						errors: {
							...this.state.errors,
							player: response.data.message
						}
					});
				} else {
					this.setState({
						playersLoading: false,
						players: response.data
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						playersLoading: false,
						errors: {
							...this.state.errors,
							player: err.response.data.errors ? err.response.data.errors : err.response.data.message
						}
					});
				} else {
					this.setState({
						playersLoading: false,
						errors: {
							...this.state.errors,
							player: err.message
						}
					});
				}
			});
	}

	/// ===================================================================================
	//  REACT-SELECT
	// ===================================================================================
	selectOption = item => {
		return (
			<span>
				{item.number} - {item.name}
			</span>
		);
	};

	// ===================================================================================
	//  VALUE CHANGES
	// ===================================================================================
	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSubmit();
		}
	}

	handleInputChange(event) {
		const { id, value } = event.target;
		this.setState({
			data: {
				...this.state.data,
				[id]: value
			}
		});
	}

	handleRadioClick(event, name) {
		const { value } = event.target;
		this.setState({
			data: {
				...this.state.data,
				[name]: value
			}
		});
	}

	handleNumberChange(id, valueObject) {
		this.setState({
			data: {
				...this.state.data,
				[id]: valueObject.value
			}
		});
	}

	editorChange(evt) {
		const newContent = evt.editor.getData();
		const newData = {
			...this.state.data,
			notes: newContent
		};

		this.setState({ data: newData });
	}

	setCKEditorReadonly() {
		// Stop-gap fix to ensure editorInstance is set before trying to use it.
		// I think it's because live the site is SSR, so the ref is set before the CKEditor scripts actually load
		if (!!this.ckeditor.editorInstance) {
			this.ckeditor.editorInstance.setReadOnly(this.state.submitLoading);
		}
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit() {
		const { data } = this.state;

		this.setState(
			{
				errors: {},
				submitLoading: true
			},
			() => {
				this.setCKEditorReadonly();

				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
				return axios
					.post(REACT_APP_API_URL + "custom/spitsgear/jersey-form", data, { headers: AUTH_HEADER })
					.then(({ data }) => {
						// ===================================
						//  Errors
						// ===================================
						if (!isEmpty(data.errors)) {
							this.setState({
								submitLoading: false,
								errors: data.errors
							});
							this.setCKEditorReadonly();
							return;
						}

						// ===================================
						//  Redirect to print page
						// ===================================
						this.handleDeleteRedirect(data.id);
					})
					.catch(err => {
						if (err.response) {
							this.setState({
								submitLoading: false,
								errors: {
									general: err.response.data.error ? err.response.data.error : err.response.data.message
								}
							});
						} else {
							this.setState({
								submitLoading: false,
								errors: { general: err.message }
							});
						}

						this.setCKEditorReadonly();
					});
			}
		);
	}

	handleDeleteRedirect(id) {
		this.props.history.push(`/jersey-form/print/${id}`);
	}

	render() {
		const { errors, playersLoading, submitLoading, players, productTypes, sizeTypes, styleTypes, conditionTypes, data } = this.state;
		const styleOptions = styleTypes[data.product] ? styleTypes[data.product] : null;

		return (
			<main className="body_container padded_top padded_bottom">
				<div className="instruction">Internal Crease Apparel Shop Form Only</div>

				<div className="fieldset">
					<label className="title-label">Customer Information</label>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>First Name:</label>

							{errors.fname && <div className="error msg_animate">{errors.fname}</div>}
							<input type="text" id="fname" value={data.fname ? data.fname : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
						</div>

						<div className="form-field half-field">
							<label>Last Name:</label>

							{errors.lname && <div className="error msg_animate">{errors.lname}</div>}
							<input type="text" id="lname" value={data.lname ? data.lname : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Phone:</label>

							{errors.phone && <div className="error msg_animate">{errors.phone}</div>}
							<NumberFormat type="tel" value={data.phone ? data.phone : ""} format="### ### ####" mask="_" onKeyPress={e => this.handleKeyPress(e)} onValueChange={e => this.handleNumberChange("phone", e)} disabled={submitLoading} />
						</div>

						<div className="form-field half-field">
							<label>Staff Name:</label>

							{errors.staff_name && <div className="error msg_animate">{errors.staff_name}</div>}
							<input type="text" id="staff_name" value={data.staff_name ? data.staff_name : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Date Ordered:</label>

							{errors.date_ordered && <div className="error msg_animate">{errors.date_ordered}</div>}
							<input type="text" id="date_ordered" value={data.date_ordered ? data.date_ordered : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
						</div>

						<div className="form-field half-field">
							<label>Receipt Number:</label>

							{errors.receipt_number && <div className="error msg_animate">{errors.receipt_number}</div>}
							<input type="text" id="receipt_number" value={data.receipt_number ? data.receipt_number : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field">
							<label>Notes:</label>

							{!!errors.notes && <div className="error msg_animate">{errors.notes}</div>}
							<CKEditor
								scriptUrl="/ckeditor/ckeditor.js"
								content={data.notes ? data.notes : ""}
								config={{ removePlugins: "elementspath,uploadimage,uploadfile", toolbar: "None" }}
								events={{ instanceReady: editorReady.bind(this), change: this.editorChange.bind(this) }}
								ref={instance => {
									this.ckeditor = instance;
								}}
							/>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<label className="title-label">Product</label>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Product:</label>

							{!!errors.product && <div className="error msg_animate">{errors.product}</div>}
							<Select name={`product`} placeholder="Choose the product type" value={data.product ? data.product : ""} onChange={selection => this.setState({ data: { ...this.state.data, product: selection.value } })} clearable={false} valueKey="value" labelKey="label" options={productTypes} disabled={submitLoading} />
						</div>

						{data.product &&
							data.product === "Other" && (
								<div className="form-field half-field">
									<label>Other:</label>

									{errors.other_product && <div className="error msg_animate">{errors.other_product}</div>}
									<input type="text" id="other_product" value={data.other_product ? data.other_product : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
								</div>
							)}
					</div>

					{styleOptions && (
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Style:</label>

								{!!errors.style && <div className="error msg_animate">{errors.style}</div>}
								<Select name={`style`} placeholder="Choose the style type" value={data.style ? data.style : ""} onChange={selection => this.setState({ data: { ...this.state.data, style: selection.value } })} clearable={false} valueKey="value" labelKey="label" options={styleOptions} disabled={submitLoading} />
							</div>

							{data.style &&
								data.style === "Other" && (
									<div className="form-field half-field">
										<label>Other:</label>

										{errors.other_style && <div className="error msg_animate">{errors.other_style}</div>}
										<input type="text" id="other_style" value={data.other_style ? data.other_style : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
									</div>
								)}
						</div>
					)}

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Size:</label>

							{!!errors.size && <div className="error msg_animate">{errors.size}</div>}
							<Select name={`size`} placeholder="Choose the product size" value={data.size ? data.size : ""} onChange={selection => this.setState({ data: { ...this.state.data, size: selection.value } })} clearable={false} valueKey="value" labelKey="label" options={sizeTypes} disabled={submitLoading} />
						</div>

						{data.size &&
							data.size === "Other" && (
								<div className="form-field half-field">
									<label>Other:</label>

									{errors.other_size && <div className="error msg_animate">{errors.other_size}</div>}
									<input type="text" id="other_size" value={data.other_size ? data.other_size : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
								</div>
							)}
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Condition:</label>

							{!!errors.condition && <div className="error msg_animate">{errors.condition}</div>}
							<Select name={`condition`} placeholder="Choose the condition type" value={data.condition ? data.condition : ""} onChange={selection => this.setState({ data: { ...this.state.data, condition: selection.value } })} clearable={false} valueKey="value" labelKey="label" options={conditionTypes} disabled={submitLoading} />
						</div>
					</div>
				</div>

				<div className="fieldset">
					<label className="title-label">Customization</label>

					<div className="instruction">Please select either Custom Name or Roster Name.</div>

					{!!errors.name_option && <div className="error msg_animate">{errors.name_option}</div>}

					<div className="form-field">
						<div className="custom-label checkbox-label no-bottom-margin">
							<input type="radio" name="name_option" id="name_option_0" value="Custom Name" checked={data.name_option === "Custom Name"} onChange={e => this.handleRadioClick(e, "name_option")} disabled={submitLoading} />
							<label htmlFor="name_option_0">Custom Name</label>
						</div>
					</div>
					<div className="form-field">
						<div className="custom-label checkbox-label no-bottom-margin">
							<input type="radio" name="name_option" id="name_option_1" value="Roster Name" checked={data.name_option === "Roster Name"} onChange={e => this.handleRadioClick(e, "name_option")} disabled={submitLoading} />
							<label htmlFor="name_option_1">Roster Name</label>
						</div>
					</div>
					<div className="form-field">
						<div className="custom-label checkbox-label no-bottom-margin">
							<input type="radio" name="name_option" id="name_option_2" value="Special Request" checked={data.name_option === "Special Request"} onChange={e => this.handleRadioClick(e, "name_option")} disabled={submitLoading} />
							<label htmlFor="name_option_2">Special Request</label>
						</div>
					</div>

					{data.name_option &&
						data.name_option === "Custom Name" && (
							<div className="floated-field-container">
								<div className="form-field half-field">
									<label>Custom Name:</label>

									{errors.custom_name && <div className="error msg_animate">{errors.custom_name}</div>}
									<input type="text" id="custom_name" value={data.custom_name} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
								</div>

								<div className="form-field half-field">
									<label>Custom Number:</label>

									{errors.custom_number && <div className="error msg_animate">{errors.custom_number}</div>}
									<input type="number" id="custom_number" value={data.custom_number} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
								</div>
							</div>
						)}

					{data.name_option &&
						data.name_option === "Roster Name" && (
							<div className="floated-field-container">
								<div className="form-field half-field">
									<label>Player Roster:</label>

									{!!errors.player && <div className="error msg_animate">{errors.player}</div>}
									{playersLoading ? (
										<div className="pt1 pb1 pl1 no-margin-loader">
											<Loader />
										</div>
									) : (
										<Select name={`player`} placeholder="Choose player" value={data.player ? data.player : ""} onChange={selection => this.setState({ data: { ...this.state.data, player: selection.id } })} clearable={false} valueKey="id" optionRenderer={this.selectOption} valueRenderer={this.selectOption} options={players} disabled={submitLoading} />
									)}
								</div>
							</div>
						)}

					{data.name_option &&
						data.name_option === "Special Request" && (
							<div className="form-field">
								<label>Special Instructions:</label>

								{errors.special_instructions && <div className="error msg_animate">{errors.special_instructions}</div>}
								<input type="text" id="special_instructions" value={data.special_instructions ? data.special_instructions : ""} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} disabled={submitLoading} />
							</div>
						)}
				</div>

				<div className="fieldset">
					<label className="title-label">Additional Options (Caption or Alternate Letter)</label>

					{!!errors.additional_option && <div className="error msg_animate">{errors.additional_option}</div>}

					<div className="form-field">
						<div className="custom-label checkbox-label no-bottom-margin">
							<input type="radio" id="additional_option_0" name="additional_option" value="None" checked={data.additional_option === "None"} onChange={e => this.handleRadioClick(e, "additional_option")} disabled={submitLoading} />
							<label htmlFor="additional_option_0">None</label>
						</div>
						<div className="custom-label checkbox-label no-bottom-margin">
							<input type="radio" id="additional_option_1" name="additional_option" value="Captain" checked={data.additional_option === "Captain"} onChange={e => this.handleRadioClick(e, "additional_option")} disabled={submitLoading} />
							<label htmlFor="additional_option_1">Captain</label>
						</div>
						<div className="custom-label checkbox-label no-bottom-margin">
							<input type="radio" id="additional_option_2" name="additional_option" value="Alternate" checked={data.additional_option === "Alternate"} onChange={e => this.handleRadioClick(e, "additional_option")} disabled={submitLoading} />
							<label htmlFor="additional_option_2">Alternate</label>
						</div>
					</div>
				</div>

				<div className="btn_container">
					{!!errors.general && <div className="error msg_animate" dangerouslySetInnerHTML={{ __html: sanitizeHtml(errors.general) }} />}

					<button className={"btn submit-btn" + (submitLoading ? " loading" : "")} onClick={() => this.handleSubmit()} disabled={submitLoading}>
						<span>Submit</span>
					</button>
				</div>
			</main>
		);
	}
}

export default JerseyForm;



// WEBPACK FOOTER //
// ./src/components/custom/jersey-form/JerseyForm.js